export const DATA = 'DATA'
export const TOKEN = 'TOKEN'
export const CHECK_AUTH = 'CHECK_AUTH'



// WEBPACK FOOTER //
// ./src/vuex/users/types.js